var map = {
	"./0.mp3": 59,
	"./1.mp3": 60,
	"./10.mp3": 61,
	"./2.mp3": 62,
	"./3.mp3": 63,
	"./5.mp3": 64,
	"./6.mp3": 65,
	"./7.mp3": 66,
	"./8.mp3": 67,
	"./9.mp3": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;